"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeMasterStyleAssignments = decodeMasterStyleAssignments;
const decoded_types_1 = require("../decoded-types");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const entity_list_1 = require("./entity-list");
function decodeMasterStyleAssignments(slot, path, warnings) {
    if (slot === undefined) {
        return [];
    }
    if (slot.type !== 'container' && slot.type !== 'econtainer') {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.UnrecognizedShape,
            message: `expected container for Root[0], got ${slot.type}`,
            severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            path,
        });
        return [];
    }
    const detected = (0, entity_list_1.detectEntityList)(slot.children);
    if (detected === null) {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.UnrecognizedShape,
            message: `Root[0] does not open with (count, typeCode)`,
            severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            path,
        });
        return [];
    }
    if (detected.typeCode !== '12') {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.UnknownTypeCode,
            message: `expected Root[0] typeCode=12, found ${detected.typeCode}`,
            severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            path,
        });
        return [];
    }
    const out = [];
    const items = (0, entity_list_1.entityListItems)(slot);
    for (const [idx, item] of items.entries()) {
        const itemPath = `${path}/items[${idx}]`;
        if (item.type !== 'text') {
            warnings.push({
                type: decoded_types_1.DecodeWarningType.UnrecognizedShape,
                message: `expected text row in Root[0], got ${item.type}`,
                severity: sigma_engine_shared_1.BoundaryLevel.Warning,
                path: itemPath,
            });
            continue;
        }
        const parsed = parseStyleAssignmentRow(item.content);
        if (parsed === null) {
            warnings.push({
                type: decoded_types_1.DecodeWarningType.InvariantViolation,
                message: `Root[0] row has fewer than 3 whitespace-separated fields: ${JSON.stringify(item.content)}`,
                severity: sigma_engine_shared_1.BoundaryLevel.Error,
                path: itemPath,
            });
            continue;
        }
        out.push({ kind: 'style-assignment', ...parsed, raw: item });
    }
    if (out.length !== detected.declaredCount) {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.InvariantViolation,
            message: `Root[0] declared count=${detected.declaredCount} but decoded ${out.length} rows`,
            severity: sigma_engine_shared_1.BoundaryLevel.Error,
            path,
        });
    }
    return out;
}
function parseStyleAssignmentRow(text) {
    const tokens = text.trim().split(/\s+/);
    if (tokens.length < 3) {
        return null;
    }
    return { pageNum: tokens[0], rowIndex: tokens[1], styleName: tokens.slice(2).join(' ') };
}
//# sourceMappingURL=decode-master-style-assignments.js.map